<div class="mlwf">
  <!-- Only while a bar is open: the way back, and which bar this is. -->
  <div class="mlwf-toolbar" *ngIf="currentView === 'waterfall'">
    <button type="button" class="mlwf-back-btn" (click)="showBarsView()">
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <line x1="19" y1="12" x2="5" y2="12" />
        <polyline points="12 19 5 12 12 5" />
      </svg>
      Back
    </button>
    <span class="mlwf-view-label">{{ waterfallName }}</span>
  </div>

  <div
    #chartEl
    class="mlwf-chart"
    [class.view-waterfall]="currentView === 'waterfall'"
  ></div>
</div>
